function listArrayObject({ arr, id }) {
  if (!arr) {
    return "";
  }

  return arr.map((item) => item[id]).join(" - ");
}

export default listArrayObject;
